import selectMarkAsReadOption, { MarkAsReadChoiceKey } from '../actions/selectMarkAsReadOption';
import MarkAsReadOptionState from '../store/schema/MarkAsReadOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

export interface MarkAsReadFullProps {
    optionStore?: MarkAsReadOptionState;
    userOptions?: UserOptionsType;
}

// This interface is here to catch any changes in the MarkAsRead type, as used by this class for choice keys.
interface MarkAsReadChoice {
    key: MarkAsReadChoiceKey;
    text: string;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class MarkAsReadFull extends React.Component<MarkAsReadFullProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;
        let behavior = getFallbackValueIfNull(optionStore.behavior, userOptions.PreviewMarkAsRead);
        let delay = getFallbackValueIfNull(optionStore.delay, userOptions.MarkAsReadDelaytime);

        let selectedKey = behavior === 'Delayed' && delay === 0 ? 'Instant' : behavior;

        let choices: MarkAsReadChoice[] = [
            {
                key: 'Instant',
                text: strings.options_mail_markAsReadInstant,
            },
            {
                key: 'Delayed',
                // TODO: VSO:13206 -Need to make a change to Fabric to allow for a dropdown inline as part of a choice
                // https://github.com/OfficeDev/office-ui-fabric-react/issues/1765
                text: strings.options_mail_markAsReadDelayed,
            },
            {
                key: 'OnSelectionChange',
                text: strings.options_mail_markAsReadSelectionChange,
            },
            {
                key: 'Never',
                text: strings.options_mail_markAsReadNever,
            },
        ];

        return <ChoiceGroup selectedKey={selectedKey} options={choices} onChange={this.onChange} />;
    }

    private onChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectMarkAsReadOption(option.key as MarkAsReadChoiceKey);
    };
}
